const toUserGroupsApiSpec = (selection) => {
  return selection.map((entity) => {
    let type = 'users';
    if (entity.companyId) {
      type = 'companies';
    } else if (entity.teamId) {
      type = 'teams';
    }
    return {
      id: Number(entity.id) || Number(entity.companyId) || Number(entity.teamId),
      type,
    };
  });
};

const toUserGroupsCamelCase = (selection) => {
  return selection.reduce(
    (entity, party) => {
      if (party.companyId) {
        return {
          ...entity,
          companyIds: entity.companyIds.concat(Number(party.companyId)),
        };
      }
      if (party.teamId) {
        return {
          ...entity,
          teamIds: entity.teamIds.concat(Number(party.teamId)),
        };
      }
      if (party.id) {
        return {
          ...entity,
          userIds: entity.userIds.concat(Number(party.id)),
        };
      }
      return entity;
    },
    {
      companyIds: [],
      teamIds: [],
      userIds: [],
    },
  );
};

const toUserGroupsPascalCase = (selection) => {
  return selection.reduce(
    (entity, party) => {
      if (party.companyId) {
        return {
          ...entity,
          CompanyIDs: entity.CompanyIDs.concat(Number(party.companyId)),
        };
      }
      if (party.teamId) {
        return {
          ...entity,
          TeamIDs: entity.TeamIDs.concat(Number(party.teamId)),
        };
      }
      if (party.id) {
        return {
          ...entity,
          UserIDs: entity.UserIDs.concat(Number(party.id)),
        };
      }
      return entity;
    },
    {
      CompanyIDs: [],
      TeamIDs: [],
      UserIDs: [],
    },
  );
};

/**
 * @param assignedTo Array - List of assigned users, companies, teams
 * @returns a Promise to a Schema objects - { assignedTo, userGroupsCamelCase, userGroupsPascalCase, userGroupApiSec }
 */
export default function useUserGroupPicker({ modalManager }) {
  const openUserGroupPicker = (
    {
      projectId,
      assignedTo = [],
      itemId = 0,
      privacyIds = [],
      itemType = 'notebooks',
      title = 'Choose life',
      isInitalOptionSelected,
      initialOptionText,
      shouldUseInitialOptions,
      pickerType,
      peopleEndpoint,
      teamsEndpoint,
      includeMe,
      showIncludeMe,
    },
    { iframe = null } = {},
  ) => {
    return new Promise((resolve) => {
      modalManager.openHybridModal(
        'user-group-picker-modal',
        {
          projectId: Number(projectId) || 0,
          itemId,
          privacyIds,
          itemType,
          title,
          isInitalOptionSelected,
          initialOptionText,
          shouldUseInitialOptions,
          pickerType,
          peopleEndpoint,
          teamsEndpoint,
          includeMe,
          showIncludeMe,
          callback: (newAssignedTo, everyoneOrAnyone) => {
            const userGroupsCamelCase = toUserGroupsCamelCase(newAssignedTo);
            const userGroupsPascalCase = toUserGroupsPascalCase(newAssignedTo);
            const userGroupsApiSpec = toUserGroupsApiSpec(newAssignedTo);
            resolve({
              assignedTo: newAssignedTo,
              everyoneOrAnyone,
              userGroupsCamelCase,
              userGroupsPascalCase,
              userGroupsApiSpec,
            });
          },
          assignedTo,
        },
        { iframe },
      );
    });
  };

  return {
    openUserGroupPicker,
  };
}
